import script from "./QuotationFormPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotationFormPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuotationFormPage.vue?vue&type=style&index=0&id=1f28dce3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f28dce3"]])

export default __exports__